import {AuthenticationNs, TokenNs, WorkspaceNs} from "@shared/types";
import {useAuthStore} from "@domains/auth/stores/auth.store";
import {getBaseDomain, isDevelopmentEnv} from "@shared/helpers/get-env-url.helper";
import {cookies} from "@shared/helpers/common.helper";
import {COOKIE_NAMES} from "@shared/constants/common.constants";
import router from "@/router";
import {toast} from '@shared/ms-components'

export const getStoredToken = (): TokenNs.TokenData => {
    const authStore = useAuthStore()
    let token = authStore.getToken;
    if (!token || !token.accessToken) {
        const tokenStr = cookies.get(COOKIE_NAMES.TOKEN);
        if (tokenStr) {
            try {
                token = JSON.parse(tokenStr) as TokenNs.TokenData;
            } catch (e) {
               console.log(e)
            }
        }

    }
    return token;
};

export const getStoredPublicToken = (): TokenNs.TokenData => {
  const authStore = useAuthStore()
  let token = authStore.getPublicToken;
  if (!token || !token.accessToken) {
    const tokenStr = cookies.get(COOKIE_NAMES.PUBLIC_TOKEN);
    if (tokenStr) {
      try {
        token = JSON.parse(tokenStr) as TokenNs.TokenData;
      } catch (e) {
        console.log(e)
      }
    }
  }
  return token;
};

export const setWorkspaceToCookie = (selectedWorkspace: WorkspaceNs.Workspace): void => {
  const selectedWs = {
    id: selectedWorkspace.id,
    name: selectedWorkspace.name
  } as WorkspaceNs.SelectedWorkspaceInfo;
  cookies.set(COOKIE_NAMES.WORKSPACE, JSON.stringify(selectedWs), {domain: getBaseDomain});
};

export const goToWorkspace = (selectedWorkspace: WorkspaceNs.Workspace, $router?: any, next?: any): void => {
  setWorkspaceToCookie(selectedWorkspace);
  if (isDevelopmentEnv) {
    if ($router) $router.push({name: 'Loading'});
    if (next) next({name: 'Loading'});
  } else {
    window.location.href = `https://${selectedWorkspace.name}${getBaseDomain}/loading`;
  }
};

const redirectToSignIn = (): void => {
    const isAuthPage = window.location.href.indexOf('/auth/') > -1;

    toast.error('Please sign in')
    router.push({name: AuthenticationNs.AuthenticationRouteEnums.SignIn});
};

export const getToken = (): TokenNs.TokenData => {
    const token = getStoredToken();
    if (token && token.accessToken) {
        return token;
    }

    redirectToSignIn();
    return {} as TokenNs.TokenData;
};

export const getPublicToken = (): TokenNs.TokenData => {
    const token = getStoredPublicToken();
    if (token && token.accessToken) {
        return token;
    }

    return {} as TokenNs.TokenData;
};
